import { BaseURL } from "../../config";

export const FETCH_TEMP_ORDER_API = `${BaseURL}/app/csvupload/tempcart`;

export const tempCartToken = 'tempCart_mrOrderID';